module.exports = __webpack_public_path__ + "static/media/video.b4355d10.mp4";